// The backend accepts POST /send-contract bodies up to 20mb (contractJsonBody
// .ts). The JSON wrapper (name, email, file name) is tiny, so a base64 PDF
// over 19 MiB leaves no safe margin. Checked BEFORE the delivery receipt is
// claimed: an oversized PDF is a definite local failure, never an
// "uncertain" send, and the receipt stays exactly as it was (resendable).
export const MAX_EMAIL_PDF_BASE64_LENGTH = 19 * 1024 * 1024

export class EmailAttachmentTooLargeError extends Error {
  readonly base64Length: number
  constructor(base64Length: number) {
    super(
      'The signed PDF is too large to email (' +
        (base64Length / 1048576).toFixed(1) +
        ' MB, limit ' +
        MAX_EMAIL_PDF_BASE64_LENGTH / 1048576 +
        ' MB). Nothing was sent. Download the PDF and contact support.',
    )
    // tsconfig.web targets es5: keep instanceof working on Error subclasses.
    Object.setPrototypeOf(this, EmailAttachmentTooLargeError.prototype)
    this.name = 'EmailAttachmentTooLargeError'
    this.base64Length = base64Length
  }
}

export function assertEmailAttachmentSize(pdfBase64: string): void {
  if (pdfBase64.length > MAX_EMAIL_PDF_BASE64_LENGTH)
    throw new EmailAttachmentTooLargeError(pdfBase64.length)
}
